import React, {useEffect, useMemo} from 'react';
import PropTypes from 'prop-types';
import FormDynamic from "../../../../Utils/Form/FormDynamic";
import JsonScreenHoc from "../../../../HocHelpers/JsonScreenHoc";
import {useDispatch, useSelector} from "react-redux";
import {setArrayPath} from "../../../../Utils/Form/FormDynamic/Utils/setArrayPath";
import {setComponentProperty} from "../../jsonScreen.slice";

const FieldScreenComponent = (props) => {
    const {
        field,
        setValue,
        insertValue,
        showLabel,
        goBack,
        history,
        onBlurFromCell,
        focusNow,
        containerArrayPath,
        basePath,
        doActions,
        actionsContext,
        screenName
    } = props;
    const fieldStyles = field.styles[0];
    const labelStyles = field.styles[1];

    //redux state
    const globalValues = useSelector(state => state.jsonScreen.globalValues)
    const allFieldsDisabled = useSelector(state => state.jsonScreen.allFieldsDisabled)
    const forms = useSelector(state => state.jsonScreen.forms)
    const dispatch = useDispatch();
    let {properties, events} = field;

    if (basePath) {
        properties = appendBasePath(properties, basePath)
    }
    useEffect(() => {
        if (containerArrayPath) {
            dispatch(setComponentProperty({
                componentId: field.id,
                property: 'arrayPath',
                value: setArrayPath(properties.path, containerArrayPath)
            }))
        }
    }, []);
    const fieldsInfo = useMemo(() => {
        const info = getFieldFormData(containerArrayPath ? setArrayPath(properties.path, containerArrayPath) : properties.path, forms);
        return info || {};
    }, [properties.path, containerArrayPath, JSON.stringify(forms), JSON.stringify(globalValues.param[screenName])])

    return (
        <FormDynamic
            field={{...properties, children: field.children, id: field.id, formInfo: fieldsInfo}}
            events={events}
            values={globalValues.param[screenName]}
            setValue={setValue}
            insertValue={insertValue}
            fieldStyles={fieldStyles}
            labelStyles={labelStyles}
            showLabel={showLabel}
            goBack={goBack}
            errors={fieldsInfo.errors}
            history={history}
            doActions={doActions}
            globalValues={globalValues}
            actionsContext={actionsContext}
            //from table
            onBlurFromCell={onBlurFromCell}
            focusNow={focusNow}
            containerArrayPath={containerArrayPath}
            allFieldsDisabled={allFieldsDisabled}
            screenName={screenName}
        />
    );
};

FieldScreenComponent.propTypes = {
    field: PropTypes.object.isRequired,
    setValue: PropTypes.func,
    goBack: PropTypes.func,
    errors: PropTypes.array,
    history: PropTypes.object,
    onBlurFromCell: PropTypes.func,
    focusNow: PropTypes.bool,
    basePath: PropTypes.string,
    allFieldsDisabled: PropTypes.bool
};

export default JsonScreenHoc(FieldScreenComponent);

function appendBasePath(field, basePath) {
    let newField = {...field};
    newField.path = basePath + '.' + field.path;
    return newField;
}

function getFieldFormData(path, forms) {
    if (!forms) return;

    const entity = path.split('.')[0];
    const form = forms[entity]

    if (!entity || !form) return {};

    const label = form.label?.find(v => entity + '.' + v.field === path)?.text;

    return {label, errors: form.status?.message || []}
    // [
    // {field: 'id', text: "Error Message"},
    //     {field: 'reqDateTime', text: "Error Message"},
    //     {field: 'deliveryChannel', text: "Error Message"},
    //     {field: 'commissionFeeOrig.currency', text: "Error Message"},
    // ]
}